import { ModelBase, ResourceBaseV2 } from "src/app/common/models/model-base";
import { Role } from "../../catalogs/roles/services/role";
import { ResourceType } from "../../catalogs/beamline-catalog/resource/resources";

export interface RSFSettings extends ResourceBaseV2 {
	type: RSFSettingType;
	defaultValue: string;
	conditions: string;
	order?: number;
}

export enum RSFSettingType {
	Notifications = 1,
	ResourceTypes = 2,
}

export interface RSFBaseSettings {
	id: number;
	name?: string;
	type: RSFSettingType,
	description?: string;
	conditions?: string;
	disabled: boolean;
	changed?: boolean;
	order?: number;
}

export interface RSFRoleNotificationSetting extends RSFBaseSettings {
	roleID?: number | null;
	role?: Role | null;
	checked?: boolean;
}

export interface RSFResourceTypesSetting extends RSFBaseSettings {
	resourceTypes?: ResourceType[];
}